(function () {
  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function initScrollFade(panel) {
    var scrollWrap = panel.querySelector('.shop-the-look-all-panel__scroll-wrap');
    var scrollEl = panel.querySelector('.shop-the-look-all-panel__products');
    if (!scrollWrap || !scrollEl || scrollWrap.dataset.fadeInit === 'true') return null;
    scrollWrap.dataset.fadeInit = 'true';

    var fadeResizeTimer;

    function updateScrollFade() {
      var maxScroll = Math.max(0, scrollEl.scrollHeight - scrollEl.clientHeight);
      var canScroll = maxScroll > 2;
      scrollWrap.classList.toggle('is-not-scrollable', !canScroll);
      scrollWrap.classList.toggle('is-scrolled-end', canScroll && scrollEl.scrollTop >= maxScroll - 2);
    }

    scrollEl.addEventListener('scroll', updateScrollFade, { passive: true });
    window.addEventListener('resize', updateScrollFade);
    window.addEventListener('load', updateScrollFade);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        clearTimeout(fadeResizeTimer);
        fadeResizeTimer = setTimeout(updateScrollFade, 100);
      }).observe(scrollEl);
    }
    updateScrollFade();

    return { scrollWrap: scrollWrap, scrollEl: scrollEl, updateScrollFade: updateScrollFade };
  }

  function scrollActiveItemIntoView(activeItem, scrollState) {
    if (!activeItem || !scrollState) return;
    var scrollEl = scrollState.scrollEl;
    var scrollWrap = scrollState.scrollWrap;
    var updateScrollFade = scrollState.updateScrollFade;
    var fadeEl = scrollWrap.querySelector('.shop-the-look-all-panel__scroll-fade');
    var fadeReserve = (fadeEl ? fadeEl.offsetHeight : 96) + 12;
    var itemTop = activeItem.offsetTop;
    var itemBottom = itemTop + activeItem.offsetHeight;
    var maxScroll = Math.max(0, scrollEl.scrollHeight - scrollEl.clientHeight);
    var targetScroll = scrollEl.scrollTop;

    if (itemBottom > scrollEl.scrollTop + scrollEl.clientHeight - fadeReserve) {
      targetScroll = itemBottom - scrollEl.clientHeight + fadeReserve;
    } else if (itemTop < scrollEl.scrollTop + 4) {
      targetScroll = itemTop - 4;
    }

    targetScroll = Math.max(0, Math.min(maxScroll, targetScroll));

    if (Math.abs(targetScroll - scrollEl.scrollTop) > 1) {
      scrollEl.scrollTo({ top: targetScroll, behavior: 'smooth' });
    } else {
      updateScrollFade();
    }
  }

  function initShopTheLookAllPanel(panel) {
    if (!panel || panel.dataset.initialized === 'true') return false;

    var hotspotId = panel.getAttribute('data-hotspot-id');
    var hotspotRoot = hotspotId ? document.getElementById(hotspotId) : null;
    if (!hotspotRoot) return false;

    var scrollState = initScrollFade(panel);
    var items = panel.querySelectorAll('.shop-the-look-product-highlight-item[data-block-id]');
    var sectionRoot = panel.closest('[id^="shopify-section-"]');
    var copyBlocks = sectionRoot ? sectionRoot.querySelectorAll('[data-look-copy-index]') : [];
    var itemBlockIds = {};

    Array.prototype.forEach.call(items, function (el) {
      itemBlockIds[el.getAttribute('data-block-id')] = true;
    });

    function defaultCopyIndex() {
      for (var i = 0; i < copyBlocks.length; i++) {
        if (copyBlocks[i].dataset.hasCopy === 'true') {
          return parseInt(copyBlocks[i].dataset.lookCopyIndex, 10);
        }
      }
      return copyBlocks.length ? parseInt(copyBlocks[0].dataset.lookCopyIndex, 10) : 0;
    }

    function showCopy(index) {
      copyBlocks.forEach(function (el) {
        var copyIndex = parseInt(el.dataset.lookCopyIndex, 10);
        var visible = copyIndex === index && el.dataset.hasCopy === 'true';
        el.classList.toggle('hidden', !visible);
      });
    }

    function readLookIndex(hotspot) {
      var raw = hotspot.getAttribute('data-look-index');
      var parsed = parseInt(raw, 10);
      return isNaN(parsed) ? null : parsed;
    }

    function setActive(blockId, lookIndex) {
      if (!blockId || !itemBlockIds[blockId]) return;

      Array.prototype.forEach.call(items, function (el) {
        el.classList.toggle('is-hotspot-active', el.getAttribute('data-block-id') === blockId);
      });

      Array.prototype.forEach.call(
        hotspotRoot.querySelectorAll('.x-hotspot[data-block-id]'),
        function (hotspot) {
          hotspot.classList.toggle('active-hotspot', hotspot.getAttribute('data-block-id') === blockId);
        }
      );

      var resolvedLookIndex = typeof lookIndex === 'number' && !isNaN(lookIndex) ? lookIndex : defaultCopyIndex();
      var copyBlock = sectionRoot
        ? sectionRoot.querySelector('[data-look-copy-index="' + resolvedLookIndex + '"]')
        : null;
      showCopy(copyBlock && copyBlock.dataset.hasCopy === 'true' ? resolvedLookIndex : defaultCopyIndex());

      var activeItem = panel.querySelector(
        '.shop-the-look-product-highlight-item[data-block-id="' + blockId + '"]'
      );

      if (!isMobileViewport()) {
        scrollActiveItemIntoView(activeItem, scrollState);
      }
    }

    function activateFromHotspot(hotspot, e) {
      if (!hotspot) return;
      if (e && e.type === 'click') e.preventDefault();
      setActive(hotspot.getAttribute('data-block-id'), readLookIndex(hotspot));
    }

    hotspotRoot.addEventListener('click', function (e) {
      activateFromHotspot(e.target.closest('.x-hotspot[data-block-id]'), e);
    });

    hotspotRoot.addEventListener('mouseover', function (e) {
      activateFromHotspot(e.target.closest('.x-hotspot[data-block-id]'));
    });

    hotspotRoot.addEventListener('focusin', function (e) {
      activateFromHotspot(e.target.closest('.x-hotspot[data-block-id]'));
    });

    Array.prototype.forEach.call(items, function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        setActive(el.getAttribute('data-block-id'), parseInt(el.getAttribute('data-hotspot-index'), 10));
      });
    });

    if (items.length) {
      setActive(
        items[0].getAttribute('data-block-id'),
        parseInt(items[0].getAttribute('data-hotspot-index'), 10)
      );
    } else {
      showCopy(defaultCopyIndex());
    }

    panel.dataset.initialized = 'true';
    return true;
  }

  function initAll() {
    document.querySelectorAll('.shop-the-look-all-panel').forEach(initShopTheLookAllPanel);
  }

  window.ShopTheLookAllPanel = {
    init: initShopTheLookAllPanel,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
